module.exports = __webpack_public_path__ + "img/50.a3af7c49.jpg";